import script from "./CircleSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./CircleSpinner.vue?vue&type=script&setup=true&lang=js"

import "./CircleSpinner.vue?vue&type=style&index=0&id=5061863c&lang=scss&scoped=true"
script.__scopeId = "data-v-5061863c"

export default script